<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-card-title primary-title>
                  OldBalane
                </v-card-title>
                <v-chip-group text-color="white" column dark>
                  <template v-for="(item, index) in OldBalanceArray">
                    <v-chip
                      pill
                      :color="item.loan === 'yess' ? '#E57373' : 'black'"
                      text-color="white"
                      light
                      :key="index"
                      >{{ item.Amount.toLocaleString() }}
                      <v-avatar
                        size="avatarSize"
                        :color="item.loan === 'yess' ? '#D50000' : '#FFECB3'"
                        class="black--text pa-4 my-4"
                        right
                      >
                        {{ item.AmountType | MoneySigns }}
                      </v-avatar>
                    </v-chip>
                  </template>
                </v-chip-group>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-card-title primary-title>
                  Total Balance
                </v-card-title>
                <v-chip-group text-color="white" column dark>
                  <template v-for="(item, index) in AvailibleBalanceArray">
                    <v-chip
                      pill
                      :color="item.loan === 'yess' ? '#E57373' : 'black'"
                      text-color="white"
                      light
                      :key="index"
                      >{{ item.Amount.toLocaleString() }}
                      <v-avatar
                        size="avatarSize"
                        :color="item.loan === 'yess' ? '#D50000' : '#FFECB3'"
                        class="black--text pa-4 my-4"
                        right
                      >
                        {{ item.AmountType | MoneySigns }}
                      </v-avatar>
                    </v-chip>
                  </template>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <template v-if="ClientName.length > 0">
              {{ ClientName[0].FullName }}
            </template>

            <!-- {{ CustomersList }} -->
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-search"
              label="Search"
              single-line
              hide-details
              class="d-print-none"
            ></v-text-field>
            <v-btn
              v-if="Transactions.length"
              icon
              class="d-print-none"
              @click="PrintPage"
              small
              color="success"
            >
              <v-icon>mdi-printer-settings</v-icon>
            </v-btn>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="Transactions"
            :search="search"
            :items-per-page="itemPerPage"
          >
            <template v-slot:item.deposit="{ item }">
              <template v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </template>
            </template>
            <template v-slot:item.withdraw="{ item }">
              <template v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </template>
            </template>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2 d-print-none"
                      v-on="on"
                      >Search Account</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Search Account</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-form ref="form" class="mx-5">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model.number.lazy="AccountNumber"
                                append-icon="mdi-cloud-search-outline"
                                label="Search"
                                single-line
                                :rules="[
                                  v => !!v || 'Account Number is required',
                                ]"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="fromDate"
                                :rules="[v => !!v || 'From Date is required']"
                                required
                                name="FromDate"
                                label="From Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :loading="searching"
                                :disabled="searching"
                                v-model="toDate"
                                :rules="[v => !!v || 'To Date is required']"
                                required
                                name="ToDate"
                                label="To Date"
                                type="date"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="blue darken-1"
                        :disabled="searching"
                        text
                        @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        :loading="searching"
                        text
                        @click="OnSearch"
                        >Search</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col>
        <div>
          <cashDisplay
            inAmount="Dep"
            outAmount="Wth"
            :isloading="isloading"
            :Balance="InOUtBlc"
          ></cashDisplay>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { allReq } from "@/axiosfiles/axios-outh";
import cashDisplay from "@/components/displayCashTwo.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import { EventBus } from "../main";
export default {
  components: { cashDisplay },
  data() {
    return {
      itemPerPage: 10,
      isloading: false,
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      OldBalanceArray: [],
      AvailibleBalanceArray: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
      ],
      AccountNumber: "",
      Transactions: [],
      EmptyMessage: "",
      dialog: false,
      InOUtBlc: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["CustomersList"]),
    ClientName() {
      if (this.CustomersList.length == 0) return "";
      return this.CustomersList.filter(item => {
        return item.AccountNumber == this.AccountNumber;
      });
    },
  },
  methods: {
    async PrintPage() {
      this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.itemPerPage = 10;
    },
    TodayBalance(from, to) {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/Reports/DainlyInOut",
        data: {
          Account: "Main Cash",
          Client: this.AccountNumber,
          from,
          to,
        },
      });
    },
    OldBalane() {
      return allReq.post(`/customer/balance`, {
        AccountNumber: this.AccountNumber,
        from: "",
        to: this.fromDate,
      });
    },
    AvailibleBalance() {
      return allReq.post(`/customer/balance`, {
        AccountNumber: this.AccountNumber,
      });
    },
    TranSactions() {
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/customer/transactions",
        data: {
          AccountNumber: this.AccountNumber,
          from: this.fromDate,
          to: this.toDate,
        },
      });
    },
    MultReq() {
      return axios.all([
        this.TranSactions(),
        this.OldBalane(),
        this.AvailibleBalance(),
        this.TodayBalance(this.fromDate, this.toDate),
      ]);
    },
    close() {
      this.dialog = false;
    },
    OnSearch() {
      if (this.$refs.form.validate()) {
        this.Transactions = [];
        this.OldBalanceArray = [];
        this.AvailibleBalanceArray = [];
        this.InOUtBlc = [];

        this.searching = true;
        this.isloading = true;
        this.$store;
        this.MultReq()
          .then(result => {
            // console.log(result[0]);
            this.isloading = false;
            this.Transactions = result[0].data;
            this.OldBalanceArray = result[1].data;
            this.AvailibleBalanceArray = result[2].data;
            this.InOUtBlc = result[3].data;

            this.searching = false;
          })
          .catch(() => {
            this.isloading = false;
            // console.log(error);
            this.searching = false;
          });
      }
    },
    LoadCustomerData() {
      this.$store.dispatch("SelectAll", {
        url: "/customer",
        MutName: "Save_Customers",
      });
    },
  },
  created() {
    this.LoadCustomerData();
  },
};
</script>
